import { CalendarPlus, ExternalLink, Eye, FileText, MoreHorizontal } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@bookdental/ui";
import { CoroaDentariaIcon } from "@/components/icons/CoroaDentariaIcon";

export type OrganizacaoDoPaciente = {
  id: string;
  nome: string;
  pessoal: boolean;
  pode: { editar: boolean; agendar: boolean; pedirProtese: boolean };
};

/** Menu da linha: cada ação diz em qual clínica acontece. */
export function AcoesDoPaciente({
  nome,
  organizacao,
  onVerFicha,
  onAbrirFicha,
  onAgendar,
  onPedirProtese,
}: {
  nome: string;
  organizacao: OrganizacaoDoPaciente;
  onVerFicha: () => void;
  onAbrirFicha: () => void;
  onAgendar: () => void;
  onPedirProtese: () => void;
}) {
  const onde = organizacao.pessoal ? "" : ` em ${organizacao.nome}`;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          aria-label={`Ações de ${nome}`}
          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-muted dark:hover:text-foreground"
        >
          <MoreHorizontal className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()} className="w-64 border border-zinc-200 bg-white shadow-lg dark:border-border dark:bg-card">
        <DropdownMenuLabel className="truncate text-[11px] font-semibold uppercase tracking-wider text-zinc-500">
          {organizacao.pessoal ? "Pessoal" : organizacao.nome}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {organizacao.pessoal ? (
          <DropdownMenuItem onSelect={onAbrirFicha}>
            <FileText className="mr-2 h-4 w-4" />
            Abrir ficha
          </DropdownMenuItem>
        ) : (
          <>
            <DropdownMenuItem onSelect={onVerFicha}>
              <Eye className="mr-2 h-4 w-4" />
              Ver ficha
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={onAbrirFicha}>
              <ExternalLink className="mr-2 h-4 w-4" />
              <span className="truncate">Abrir{onde}</span>
            </DropdownMenuItem>
          </>
        )}
        {organizacao.pode.agendar && (
          <DropdownMenuItem onSelect={onAgendar}>
            <CalendarPlus className="mr-2 h-4 w-4" />
            <span className="truncate">Agendar consulta{onde}</span>
          </DropdownMenuItem>
        )}
        {organizacao.pode.pedirProtese && (
          <DropdownMenuItem onSelect={onPedirProtese}>
            <CoroaDentariaIcon className="mr-2 h-4 w-4" />
            <span className="truncate">Pedir prótese{onde}</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
